export default "__VITE_ASSET__oSSi8tp2__"